// @flow

import React from 'react';
import _ from 'lodash';

import Link from 'app/common/components/Link';
import { FormField as Item } from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

export const createMediaField = (overrides: {} = {}): Item => ({
  id: 'media',
  type: 'image',
  label: `Please provide a screenshot of the issue if applicable.`,
  details: `Screenshots are the best way to show us exactly what is going on.`,
  ..._.omit(overrides, 'details'),
});

export const taskField = {
  id: 'task',
  type: 'text',
  label: `Please provide a link to the error in your Task History if it appears there, so we can investigate the error directly.`,
  details: () => (
    <ol>
      <li>
        Find the example in your{' '}
        <Link href={`${ZAPIER_APP_BASE_URL}/app/history`} target="_blank">
          Task History
        </Link>
        .
      </li>
      <li>Copy the URL from the specific task.</li>
      <li>Paste the URL below.</li>
    </ol>
  ),
  placeholder: `https://zapier.com/app/history/12345678-12ab-cdef-0000-1a2b3c4d5e6f`,
};

export const messageField = {
  id: 'message',
  type: 'text',
  label: `How can we help you today?`,
  isMultiline: true,
  isRequired: true,
};

const userFields = [
  {
    id: 'full_name',
    type: 'text',
    label: 'Your name',
    isRequired: true,
  },
  {
    id: 'email',
    type: 'text',
    label: 'Your email address',
    isRequired: true,
  },
];

const noUserFields = [];

export const getUserFields = (isLoggedIn: boolean) =>
  isLoggedIn ? noUserFields : userFields;

export const getDefaultFields = (isLoggedIn: boolean = true) => [
  ...getUserFields(isLoggedIn),
  messageField,
];
